import dayjs from 'dayjs';
import 'dayjs/locale/it';

dayjs.locale('it');

/**
 * Formats a date to 'DD-MMM-YY' format (e.g., '15-lug-25')
 * @param {Date|string} date - The date to format
 * @returns {string} - Formatted date or 'N/A' if date is missing
 */
const formatDate = (date) => {
  if (!date) return 'N/A';
  return dayjs(date).locale('it').format('DD-MMM-YY').toLowerCase();
};

/**
 * Translates membership status to Italian
 * @param {string} status - The membership status
 * @returns {string} - The Italian translation
 */
const getMembershipStatusLabel = (status) => {
  switch (status) {
    case 'active':
      return 'Attiva';
    case 'expired':
      return 'Scaduta';
    case 'cancelled':
      return 'Cancellata';
    case 'pending':
      return 'In attesa';
    default:
      return status;
  }
};

/**
 * Escapes CSV values that contain commas, quotes, or newlines
 * @param {any} value - The value to escape
 * @returns {string} - Escaped CSV value
 */
const escapeCSV = (value) => {
  if (value === null || value === undefined) return '';
  const stringValue = String(value);
  if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

/**
 * Exports members data to CSV file
 * @param {Array} members - Array of member objects
 */
export const exportMembersToCSV = (members) => {
  // CSV Headers
  const headers = ['Tessera', 'Nome', 'Cognome', 'Email', 'Importo', 'Stato', 'Data Inizio', 'Data Fine'];
  
  // Convert members to CSV rows
  const csvRows = members.map(member => {
    const name = member.user?.name || '';
    const surname = member.user?.surname || '';
    const email = member.user?.email || '';
    const amount = member.amount ? `€${member.amount}` : '';
    const status = getMembershipStatusLabel(member.status);
    const startDate = formatDate(member.startDate);
    const endDate = formatDate(member.endDate);
    
    return [
      member.membershipId || '',
      name,
      surname,
      email,
      amount,
      status,
      startDate,
      endDate
    ];
  });
  
  // Create CSV content
  const csvContent = [
    headers.map(escapeCSV).join(','),
    ...csvRows.map(row => row.map(escapeCSV).join(','))
  ].join('\n');
  
  // Create blob and download file
  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `tesserati_${dayjs().format('YYYY-MM-DD')}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

